import LogRocket from 'logrocket'
import LogrocketFuzzySanitizer from 'logrocket-fuzzy-search-sanitizer'
import { useEffect } from 'react'

import { useUser } from '../useUser'

const PRIVATE_FIELD_NAMES = [
  'password',
  'oldPassword',
  'newPassword',
  'apiVerifyAuthenticator',
  'authenticatorUri',
  'sharedKey',
  'verificationCode',
  'username',
  'email',
  'firstName',
  'lastName',
  'userName',
  'lastLoginDate',
  'roles',
  'organisation',
  'client',
  'clients',
  'clientName',
  'clientId',
  'userId',
  'name',
  'businessUnit',
  'businessUnits',
  'businessUnitName',
  'businessUnitId',
  'metadata'
]

const { requestSanitizer, responseSanitizer } = LogrocketFuzzySanitizer.setup([
  ...PRIVATE_FIELD_NAMES
])

export const useLogRocket = () => {
  const { data: user } = useUser()
  const isOn = import.meta.env.MODE !== 'development' && import.meta.env.VITE_LOGROCKET_KEY
  useEffect(() => {
    if (isOn) {
      LogRocket.init(import.meta.env.VITE_LOGROCKET_KEY, {
        network: {
          isEnabled: true,
          requestSanitizer: request => {
            const sanitizedRequest = requestSanitizer(request as any)
            sanitizedRequest.headers = null
            return sanitizedRequest
          },
          responseSanitizer: response => {
            const sanitizedResponse = responseSanitizer(response as any)
            sanitizedResponse.headers = null
            return sanitizedResponse
          }
        }
      })
    }
  }, [isOn])
  useEffect(() => {
    if (user) {
      if (isOn) {
        LogRocket.identify(user.userId)
      }
    }
  }, [isOn, user])
}
